import React from 'react'
import ErrorMessage from '../../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../../UI/form/MyButton'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../../helpers/form/FormData'
import { checkValid, setValueForm, updateValidate } from '../../../../../../helpers/form/FormHelper'
import { useDispatch } from 'react-redux'
import { useState } from 'react'
import { useEffect } from 'react'
import { responseError } from '../../../../../../helpers/response/ResponseHelper'
import SupplyOrderItemNameField from '../../../../supplyOrders/form/items/fields/SupplyOrderItemNameField'
import SupplyOrderItemCountField from '../../../../supplyOrders/form/items/fields/SupplyOrderItemCountField'
import UnitMeasureSelectMain from '../../../../../form/fields/UnitMeasureSelectMain'
import SupplyOrderItemLinksField from '../../../../supplyOrders/form/items/fields/SupplyOrderItemLinksField'
import { editSupplyOrderItemAPI } from '../../../../../../api/supply/supplyOrderItemAPI'
import { editSupplyOrderItem } from '../../../../../../store/supplyOrderSlice'

const SupplyOrderItemForm = ({ supplyOrderItemBd, setOpen }) => {

    const dispatch = useDispatch()

  	const [data, setData] = useState(supplyOrderItemBd ? supplyOrderItemBd : {}) // Дані з форми
          
	const [valid, setValid] = useState({}) // Валідація кожного поля
	const [loading, setLoading] = useState(false)

	const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
	const [result, setResult] = useState('')
	const [error, setError] = useState('')

	useEffect(() => {
		checkValid(valid, setIsValidForm)
	}, [valid])

	const save = (e) => {
        e.preventDefault()
        const dataForBd = setDataForBd()

        console.log('dataForBd', dataForBd)

        setError('')
        setLoading(true)

        if (dataForBd.id) {
            edit(dataForBd)
        } else {
            add(dataForBd)
        }
    }

    const add = (dataForBd) => {
        // addSupplyOrderAPI(dataForBd).then(data => {
        //     dispatch(addSupplyOrder(data))
        //     setOpen(false)
        //     setLoading(false)
        // }).catch(e => {
        //     setError(responseError(e))
        //     setLoading(false)
        // })
    }

    const edit = (dataForBd) => {
        editSupplyOrderItemAPI(dataForBd).then(data => {
            if (data) {
                dispatch(editSupplyOrderItem(data))
            }
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const setDataForBd = () => {
        let dataForBd = {
            name: data.name,
            count: data.count,
            unitMeasure: data.unitMeasure,
            links: data.links,
        }

        if (data.id) {
            dataForBd = {
                ...dataForBd,
                id: data.id
            }
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
            formDataProductIsField('name', 'supplyOrderItem') ?
                <SupplyOrderItemNameField
                    required={formDataProductRequiredField('name', 'supplyOrderItem')}
                    setValidate={e => updateValidate(setValid, 'name', e)}
                    setValueForm={e => setValueForm(setData, 'name', e)}
                    forciblyValue={data && data.name ? data.name : ''}
                />
            : ''
        }
        {
            formDataProductIsField('count', 'supplyOrderItem') ?
                <SupplyOrderItemCountField
                    required={formDataProductRequiredField('count', 'supplyOrderItem')}
                    setValidate={e => updateValidate(setValid, 'count', e)}
                    setValueForm={e => setValueForm(setData, 'count', e)}
                    forciblyValue={data && data.count ? data.count : ''}
                />
            : ''
        }
        {
            formDataProductIsField('unitMeasure', 'supplyOrderItem') ?
                <UnitMeasureSelectMain
                    required={formDataProductRequiredField('unitMeasure', 'supplyOrderItem')}
                    setValidate={e => updateValidate(setValid, 'unitMeasure', e)}
                    setValueForm={e => setValueForm(setData, 'unitMeasure', e)}
                    forciblyValue={data && data.unitMeasure ? data.unitMeasure : ''}
                />
            : ''
        }
        {
            formDataProductIsField('links', 'supplyOrderItem') ?
                <SupplyOrderItemLinksField
                    required={formDataProductRequiredField('links', 'supplyOrderItem')}
                    setValidate={e => updateValidate(setValid, 'links', e)}
                    setValueForm={e => setValueForm(setData, 'links', e)}
                    forciblyValue={data && data.links ? data.links : ''}
                    rows={4}
                />
            : ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default SupplyOrderItemForm